import React, { useEffect, useState } from "react";
import FormListContainer from "../containers/FormListContainer";
import FormEditHistoryListContainer from "../containers/FormListContainer";
import FormEditService from "../services/formEditService";
import Stack from "@mui/material/Stack";
import CustomerService from "../services/customerService";
import Paper from "@mui/material/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import Table from "@mui/material/Table";
import Checkbox from "@mui/material/Checkbox";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import MenuItem from "@mui/material/MenuItem";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "@mui/material/Select";
import HeightBox from "../components/HeightBox";
import { EMPLOYEE_BLUE, WHITE } from "../colors";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { AddFinancialRecordContainerModel } from "../containers/AddFinancialRecordModelContainer";
import DocumentsListContainer from "../containers/DocumentsListContainer";
import MediaService from "../services/mediadocService";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../actions/customers";
import { DateTime } from "luxon";
const CustomInput = styled(TextField)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 200,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontSize: 18,
  backgroundColor: WHITE,
  borderRadius: 10,
  minWidth: 142,
}));

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  padding: 10,
  textAlign: "center",
}));

const Documents = () => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const { customers: customersStore } = customerList;

  const [openModel, setOpenModel] = useState(false);
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    docs: [],
    customers: [],
    filteredDocs: [],
  });

  const [searchParams, setSearchParams] = useState({
    startDate: "",
    endDate: "",
    searchedUser: "",
    searchedType: "",
  });

  const [selectedPerson, setSelectedPerson] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchedRecords, setSearchedRecords] = useState([]);
  const [userSearched, setUserSearched] = useState(false);
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  // useEffect(() => {
  //   if (selectedPerson && (startDate !== "" || startDate !== null) && (endDate !== "" || endDate !== null)) {
  //     setDisableSearchButton(false);
  //   } else {
  //     setDisableSearchButton(true);
  //   }

  useEffect(() => {
    const getPageInfo = async () => {
      setIsDataLoaded(true);
      const res = await MediaService.getAllMedia();
      if (customersStore === null) {
        dispatch(getAllCustomers());
      }
      const temp = customersStore?.map((item) => {
        return { label: item.nic, value: item.id };
      });
      setIsDataLoaded(false);

      setScreenInfo({
        ...screenInfo,
        docs: res.data,
        customers: temp,
        filteredDocs: res.data,
      });
    };

    getPageInfo();
  }, []);
  useEffect(() => {
    let filteredDocs = screenInfo.docs;

    if (searchParams.searchedType !== "" && searchParams.searchedType !== "All") {
      filteredDocs = screenInfo.docs.filter((form) => form.type === searchParams.searchedType);
    }
    if (searchParams.startDate !== "") {
      filteredDocs = screenInfo.docs.filter(
        (form) =>
          DateTime.fromISO(form.createdAt).toISO(DateTime.DATE_SHORT) >=
          DateTime.fromISO(searchParams.startDate).toISO(DateTime.DATE_SHORT)
      );
    }
    if (searchParams.endDate !== "") {
      filteredDocs = screenInfo.docs.filter(
        (form) =>
          DateTime.fromISO(form.createdAt).toISO(DateTime.DATE_SHORT) <=
          DateTime.fromISO(searchParams.endDate).toISO(DateTime.DATE_SHORT)
      );
    }
    if (searchParams.searchedUser !== "" && searchParams.searchedUser !== "All") {
      filteredDocs = screenInfo.docs.filter((form) => form.Customer.full_name.includes(searchParams.searchedUser));
    }

    if (
      searchParams.endDate !== "" ||
      searchParams.startDate !== "" ||
      searchParams.searchedUser !== "" ||
      searchParams.searchedType !== ""
    ) {
      setScreenInfo({
        ...screenInfo,
        filteredDocs: filteredDocs,
      });
    }
  }, [searchParams]);
  const clearSearchParams = () => {
    setSearchParams({
      startDate: "",
      endDate: "",
      searchedUser: "",
      searchedType: "",
    });
    setScreenInfo({
      ...screenInfo,
      filteredForms: screenInfo.formEdits,
    });
  };
  return (
    <div>
      <AddFinancialRecordContainerModel openModel={openModel} cancelFunction={() => setOpenModel(false)} />
      <Stack direction="row" spacing={5}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={searchParams.searchedUser}
          inputValue={searchParams.searchedUser}
          options={[{ label: "All", value: "All" }, ...(screenInfo?.customers ?? [])]}
          onChange={(event, value) => {
            if (value === null || value === undefined) {
              setSearchParams({
                ...searchParams,
                searchedUser: "",
              });
            } else {
              setSearchParams({
                ...searchParams,
                searchedUser: value?.label,
              });
            }
          }}
          renderInput={(params) => <CustomTextField {...params} placeholder="Default : All {Customer ID number}" />}
        />
        {/* <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={types}
          value={searchParams.searchedType}
          inputValue={searchParams.searchedType}
          onChange={(event, value) => {
            setSearchParams({ ...searchParams, searchedType: value.value });
          }}
          renderInput={(params) => <CustomInput {...params} placeholder="Select Type" style={{ width: 300 }} />}
        /> */}
        <CustomInput
          type="date"
          value={searchParams.startDate}
          onChange={(event, value) => {
            setSearchParams({
              ...searchParams,
              startDate: event.target.value,
            });
          }}
        />
        <CustomInput
          type="date"
          value={searchParams.endDate}
          onChange={(event, value) => {
            setSearchParams({
              ...searchParams,
              endDate: event.target.value,
            });
          }}
        />

        <CustomButton style={{ color: EMPLOYEE_BLUE }} onClick={clearSearchParams}>
          Clear Dates
        </CustomButton>
      </Stack>
      <HeightBox height={20} />
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <DocumentsListContainer docs={screenInfo.filteredDocs} filteredCustomer={selectedPerson?.value} />
      )}
      <HeightBox height={20} />
    </div>
  );
};

export default Documents;
